<template>
  <div class="hearing-aid-types">
    <HeroBanner
        :background-image="bannerImage"
        title="보청기 종류"
        sub-title="보청기는 착용 방식·크기·위치·기능에 따라 <br>
        청력 정도·생활 환경·편의성·심리적 요인까지 <br>
        종합적으로 판단하여 착용하게 됩니다."
    />

    <!-- 보청기 종류 섹션 -->
    <div class="types-sections">
      <!-- 오픈형 -->
      <section class="type-item">
        <div class="type-item__content">
          <h3 class="type-item__title">오픈형</h3>
        </div>
        <div class="type-item__image">
          <img
            :src="require('@/assets/images/banners/02/02-02-img-01.png')"
            :srcset="`${require('@/assets/images/banners/02/02-02-img-01.png')} 1x, ${require('@/assets/images/banners/02/02-02-img-01@2x.png')} 2x`"
            alt="오픈형"
          >
        </div>
        <div class="type-item__content">
          <table class="type-item__table">
            <tr>
              <th>특징</th>
              <td>개방감이 뛰어나 착용감 좋음</td>
            </tr>
            <tr>
              <th>외관 노출</th>
              <td>부분적 필요</td>
            </tr>
            <tr>
              <th>적합<br>난청 정도</th>
              <td>경도 ~ 중고도 난청</td>
            </tr>
            <tr>
              <th>장점</th>
              <td>최신 기능 많음(충전·블루투스)</td>
            </tr>
            <tr>
              <th>주의점</th>
              <td>저음역 난청엔 적합하지 않음</td>
            </tr>
          </table>
        </div>
      </section>

      <!-- 초소형 -->
      <section class="type-item">
        <div class="type-item__content">
          <h3 class="type-item__title">초소형</h3>
        </div>
        <div class="type-item__image">
          <img
            :src="require('@/assets/images/banners/02/02-02-img-02.png')"
            :srcset="`${require('@/assets/images/banners/02/02-02-img-02.png')} 1x, ${require('@/assets/images/banners/02/02-02-img-02@2x.png')} 2x`"
            alt="초소형"
          >
        </div>
        <div class="type-item__content">
          <table class="type-item__table">
            <tr>
              <th>특징</th>
              <td>가장 작은 보청기</td>
            </tr>
            <tr>
              <th>외관 노출</th>
              <td>거의 보이지 않음</td>
            </tr>
            <tr>
              <th>적합<br>난청 정도</th>
              <td>경도~중도 난청</td>
            </tr>
            <tr>
              <th>장점</th>
              <td>외관상 가장 티가 나지않음</td>
            </tr>
            <tr>
              <th>주의점</th>
              <td>배터리가 작아 교체 잦음</td>
            </tr>
          </table>
        </div>
      </section>

      <!-- 고막형 -->
      <section class="type-item">
        <div class="type-item__content">
          <h3 class="type-item__title">고막형</h3>
        </div>
        <div class="type-item__image">
          <img
            :src="require('@/assets/images/banners/02/02-02-img-03.png')"
            :srcset="`${require('@/assets/images/banners/02/02-02-img-03.png')} 1x, ${require('@/assets/images/banners/02/02-02-img-03@2x.png')} 2x`"
            alt="고막형"
          >
        </div>
        <div class="type-item__content">
          <table class="type-item__table">
            <tr>
              <th>특징</th>
              <td>자연스러운 소리</td>
            </tr>
            <tr>
              <th>외관 노출</th>
              <td>외관 노출 적음</td>
            </tr>
            <tr>
              <th>적합<br>난청 정도</th>
              <td>경도~중도 난청</td>
            </tr>
            <tr>
              <th>장점</th>
              <td>외관상 눈에 띄지 않음</td>
            </tr>
            <tr>
              <th>주의점</th>
              <td>귀지·습기에 약함</td>
            </tr>
          </table>
        </div>
      </section>

      <!-- 귀걸이형 -->
      <section class="type-item">
        <div class="type-item__content">
          <h3 class="type-item__title">귀걸이형</h3>
        </div>
        <div class="type-item__image">
          <img
            :src="require('@/assets/images/banners/02/02-02-img-04.png')"
            :srcset="`${require('@/assets/images/banners/02/02-02-img-04.png')} 1x, ${require('@/assets/images/banners/02/02-02-img-04@2x.png')} 2x`"
            alt="귀걸이형"
          >
        </div>
        <div class="type-item__content">
          <table class="type-item__table">
            <tr>
              <th>특징</th>
              <td>가장 강력한 출력</td>
            </tr>
            <tr>
              <th>외관 노출</th>
              <td>거의 노출됨</td>
            </tr>
            <tr>
              <th>적합<br>난청 정도</th>
              <td>중도~고심도 난청</td>
            </tr>
            <tr>
              <th>장점</th>
              <td>배터리 교체, 충전 쉬움</td>
            </tr>
            <tr>
              <th>주의점</th>
              <td>안경·마스크 착용 시 불편할 수 있음</td>
            </tr>
          </table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/02-top-img.png';
import bannerBg2 from '@/assets/images/heros/02-top-img@2x.png';

export default {
  name: 'HearingAidTypes',
  components: {HeroBanner},
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2],
    };
  }
};
</script>

<style scoped lang="scss">
.hearing-aid-types {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
}

.types-sections {
  padding: 55.8px 0 0;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.type-item {
  display: flex;
  flex-direction: column;
  gap: 33.48px;

  &__content {
    padding: 0 36px;
  }

  &__title {
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 40px;
    letter-spacing: -0.05em;
    color: #222222;
    margin: 0;
  }

  &__image {
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      display: block;
      height: auto;
      object-fit: contain;
    }
  }

  &__table {
    width: 100%;
    border-collapse: collapse;
    border-top: 1.12px solid #222222;
    border-bottom: 1.12px solid #222222;

    tr {
      border-bottom: 1.12px solid #E5E5E5;

      &:last-child {
        border-bottom: none;
      }
    }

    th {
      width: 111.61px;
      background: #F9F9F9;
      font-family: 'Noto Sans KR', sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      letter-spacing: -0.04em;
      color: #222222;
      text-align: center;
      vertical-align: middle;
      padding: 22.32px 0;
      border-right: 1.12px solid #E5E5E5;
    }

    td {
      font-family: 'Noto Sans KR', sans-serif;
      font-style: normal;
      font-weight: 350;
      font-size: 18px;
      line-height: 30px;
      letter-spacing: -0.02em;
      color: #222222;
      padding: 22.32px;
      vertical-align: middle;
    }
  }
}

@media (max-width: 768px) {
  .types-sections {
    padding: 40px 0 0;
    gap: 40px;
  }

  .type-item {
    gap: 25px;

    &__content {
      padding: 0 20px;
    }

    &__title {
      font-size: 22px;
      line-height: 36px;
    }

    &__table {
      th {
        width: 100px;
        font-size: 16px;
        line-height: 26px;
        padding: 18px 0;
      }

      td {
        font-size: 16px;
        line-height: 26px;
        padding: 18px;
      }
    }
  }
}
</style>
